import { Component, input, inject, output, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Validators, AbstractControl, FormControl, ReactiveFormsModule } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { InputSelect } from '../../models/pages/form-general.model';

@Component({
  selector: 'app-input-general-select',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule],
  templateUrl: './input-general-select.component.html',
})
export class InputGeneralSelectComponent implements OnInit {
  private translate = inject(TranslateService);

  formControlGeneral = input<FormControl | AbstractControl | null>(new FormControl());
  placeholder = input('Seleccionar...');
  label = input('');
  multiple = input(false);
  inputSelect = input<InputSelect>({ value: '', description: '' });
  arrayData = input<any[]>([]);
  translateOptions = input(false);
  selectionChange = output<any>();

  get getFormControl(): FormControl {
    return this.formControlGeneral() as FormControl;
  }

  get displayPlaceholder(): string {
    const ph = this.placeholder();
    return ph && ph.trim() !== '' ? ph : 'Seleccionar';
  }

  ngOnInit(): void {
    const ctrl = this.formControlGeneral();
    if (ctrl && (ctrl.value === null || ctrl.value === undefined)) {
      ctrl.setValue('');
    }
  }

  isRequired(): boolean {
    return !!this.formControlGeneral()?.hasValidator?.(Validators.required);
  }

  getOptionLabel(item: any): any {
    const desc = this.inputSelect().description;
    return desc === '' ? item : this.getNestedProperty(item, desc);
  }

  getNestedProperty(obj: any, path: string): any {
    const pathArray = path.split('.');
    return pathArray.reduce((acc, current) => (acc ? acc[current] : null), obj);
  }

  hasErrorState(): boolean {
    const ctrl = this.formControlGeneral();
    return !!ctrl && ctrl.invalid && (ctrl.touched || ctrl.dirty);
  }

  getErrorMessage(): string {
    const control = this.formControlGeneral();
    if (!control || !control.errors) return '';

    const errors = control.errors;

    if (errors['required']) {
      return this.translate.instant('inputs.required');
    }
    if (errors['minlength']) {
      return this.translate.instant('inputs.minlength', { requiredLength: errors['minlength'].requiredLength });
    }
    if (errors['maxlength']) {
      return this.translate.instant('inputs.maxlength', { requiredLength: errors['maxlength'].requiredLength });
    }
    if (errors['min']) {
      return this.translate.instant('inputs.min', { min: errors['min'].min });
    }
    if (errors['max']) {
      return this.translate.instant('inputs.max', { max: errors['max'].max });
    }
    if (errors['pattern']) {
      return this.translate.instant('inputs.invalidFormat');
    }

    return '';
  }

  onSelectionChange(event: any): void {
    this.selectionChange.emit(event);
  }
}
